import "@fortawesome/fontawesome-free/js/all.min";

window.FontAwesome.config.showMissingIcons = false;
window.FontAwesome.config.replacementClass = "fa";
window.FontAwesome.config.autoReplaceSvg = "nest";
window.FontAwesome.config.mutateApproach = "sync";
